<template>
  <main class="mt-3">
    <div class="container">
      <h2 class="text-center mb-5"><u>공 지 상 세</u></h2>
      <!-- <span class="fs-6 text-danger">(※ 개시이후 공지내용 변경불가)</span> -->
      <div class="mb-3 mt-2 row">
        <label class="col-md-3 col-form-label fs-5">공지제목<font class="text-danger">*</font></label>
        <div class="col-md-9">
          <input type="text" class="form-control" ref="txt_nTitle" v-model="this.notice.nTitle">
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label fs-5">공지내용<font class="text-danger">*</font></label>
        <div class="col-md-9">
          <!-- <input type="text" class="form-control" v-model="productInfo.pdtNameEng"> -->
          <textarea class="form-control" placeholder="1,000자 이내" ref="txt_nContent" id="floatingTextarea" maxlength="1000" style="height:500px" v-model="this.notice.nContent"></textarea>
        </div>
      </div>
      <!-- <div class="mb-3 row">
        <label class="col-md-3 col-form-label">공지기간<font class="text-danger">*</font></label>
        <div class="col-md-9">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1">개시</span>
            <input type="date" class="form-control" v-model="this.notice.nFrom" ref="txt_fromDate">
            <span class="input-group-text" id="basic-addon1">종료</span>
            <input type="date" class="form-control" v-model="this.notice.nTo" ref="txt_endDate">
          </div>
        </div>
      </div> -->
      <div class="mb-3 row">
        <div class="col-auto d-grid p-1">
          <button type="button" class="btn btn-lg btn-primary" @click="noticeUpdate();">내용변경</button>
        </div>        
        <div class="col-auto d-grid p-1">
          <button type="button" class="btn btn-lg btn-success" @click="goToList">공지리스트</button>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
export default {
  data() {
    return {
      notice: []
    };
  },
    // 로그인된 사용자만 접근가능페이지
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  created() {
    this.seqNotice = this.$route.query.seqNotice;
    this.getNoticeDetail(this.seqNotice);
  },  
  mounted() {
    if(this.user.handlerGrade >= 5) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/b2bLogin'});
    }
    document.getElementById("user").style.display = "none";
  },
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },    
    async getNoticeDetail(nNo) {
      let nDetail = await this.$api("/api/noticeDetail_ma", {param: [ nNo ]});

      if(nDetail.length > 0) 
      {
        this.notice = nDetail[0];
      }
    },

    goToList() {
      this.$router.push({path: '/ma_NoticeList'});
    },

    async noticeUpdate() {

      if(!this.notice.nTitle) 
      {
        this.$refs.txt_nTitle.focus();
        return this.$swal.fire("","공지제목을 입력하세요", "warning");
      }

      if(!this.notice.nContent) 
      {
        this.$refs.txt_nContent.focus();
        return this.$swal.fire("","공지내용을 입력하세요", "warning");
      }
      let updId = this.user.handlerId;
      //this.notice.nUseFlag = "N";
      // console.log("this.notice:", this.notice);

      let resUpd_notice = await this.$api("/api/noticeUpdate_ma", {param: [this.notice.nTitle, this.notice.nContent, updId, this.seqNotice]});
      if(resUpd_notice.affectedRows>0) 
      {
        this.$swal.fire('','수정완료', 'success');
        this.$router.push({path: '/ma_NoticeList'});
      }
      else 
      {
        this.$swal.fire('','수정실패', 'error');
        //this.$router.push({path: '/noticeList'});
      }
    }
  }
}
</script>